import { BordOneToneIcon } from 'components/NudosComponents';
import { bordColorTheme } from 'styles/styles.constants';
import { IToolSearchResult, TToolStatus } from 'types/quoteEditor.types';
import { filterPillsToShow } from '../../../../../../../../utils/pillsFormat';
import QuoteProductPill from '../../../../QuoteProductPill/QuoteProductPill';
import './ToolSearchResultRow.scss';

interface IToolSearchResultRow {
  tool: IToolSearchResult;
  statusLabels: Record<TToolStatus, string>;
  onSelectTool: (tool: IToolSearchResult) => void;
}

/**
 * Fila de la tabla de resultados de búsqueda de herramientas.
 * Muestra modelo, pills de características, SKU, marca y estado con dot de color.
 */
const ToolSearchResultRow = ({ tool, statusLabels, onSelectTool }: IToolSearchResultRow) => {
  const pills = filterPillsToShow(tool.pills || {});
  const status = tool.status ?? 'inactive';

  const goToCatalogProductDetails = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!tool.categoryId || !tool.id) return;
    window.open(`/catalog/create-product/${tool.categoryId}?productId=${tool.id}`, '_blank');
  };

  return (
    <tr className="toolSearchResultRow" onClick={() => onSelectTool(tool)}>
      <td>
        <div className="tdContent">
          <span className="nameText">{tool.name}</span>
        </div>
      </td>
      <td>
        <div className="tdContent pillsCellc">
          <div className="pillsRow">
            {pills.map((pill, i) => (
              <QuoteProductPill key={i} label={pill} />
            ))}
          </div>
        </div>
      </td>
      <td>
        <div className="tdContent skuCell">
          <span className="skuText">{tool.sku}</span>
          <button className="skuLink" onClick={goToCatalogProductDetails}>
            <BordOneToneIcon variant="externalLink" standardSize={12} stroke={bordColorTheme.cyan[400]} />
          </button>
        </div>
      </td>
      <td>
        <div className="tdContent">
          <span className="brandText">{tool.brand}</span>
        </div>
      </td>
      <td>
        <div className="tdContent">
          <div className={`statusCell ${status}`}>
            <span className="statusDot" />
            <span>{statusLabels[status]}</span>
          </div>
        </div>
      </td>
    </tr>
  );
};

export default ToolSearchResultRow;
